export const prescriptionDefaults = {
  sphMin: -8,
  sphMax: 8,
  sphRes: 0.25,
  cylMin: -8,
  cylMax: 8,
  cylRes: 0.25,
  addMin: 0.75,
  addMax: 4,
  addRes: 0.25,
  pdHalfMin: 25,
  pdHalfMax: 38,
  pdHalfRes: 1,
  pdMin: 51,
  pdMax: 77,
  pdRes: 1,
  pdSphRangeMin: -3,
  pdSphRangeMax: 3,
  prismVertMin: 0.5,
  prismVertMax: 5,
  prismVertRes: 0.25,
  prismBaseVert: ['Up', 'Down'],
  prismHorMin: 0.5,
  prismHorMax: 5,
  prismHorRes: 0.25,
  prismBaseHor: ['In', 'Out'],
};
